(function () {
  function initStickyFilter() {
    if (window.innerWidth > 989) return;
    var bar = document.querySelector('.mobile-facets__wrapper');
    if (!bar) return;

    var header = document.querySelector('.header-wrapper') || document.querySelector('.section-header') || document.querySelector('#shopify-section-header');

    var placeholder = document.createElement('div');
    bar.parentNode.insertBefore(placeholder, bar);

    var offsetTop = bar.getBoundingClientRect().top + window.pageYOffset;
    var stuck = false;

    function onScroll() {
      if (window.innerWidth > 989) { unstick(); return; }
      if (window.pageYOffset >= offsetTop && !stuck) stick();
      else if (window.pageYOffset < offsetTop && stuck) unstick();
    }

    function stick() {
      stuck = true;
      placeholder.style.height = bar.offsetHeight + 'px';
      bar.style.position = 'fixed';
      bar.style.top = '0';
      bar.style.left = '0';
      bar.style.right = '0';
      bar.style.zIndex = '20';
      bar.style.background = 'rgb(var(--color-background))';
      bar.style.boxShadow = '0 2px 6px rgba(0,0,0,0.08)';
      if (header) header.style.display = 'none';
    }

    function unstick() {
      stuck = false;
      placeholder.style.height = '0';
      bar.style.position = '';
      bar.style.top = '';
      bar.style.left = '';
      bar.style.right = '';
      bar.style.zIndex = '';
      bar.style.boxShadow = '';
      if (header) header.style.display = '';
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () {
      offsetTop = placeholder.getBoundingClientRect().top + window.pageYOffset;
      onScroll();
    });
  }

  if (document.readyState !== 'loading') initStickyFilter();
  else document.addEventListener('DOMContentLoaded', initStickyFilter);
})();